export default class extends Controller {
  static targets = ['form', 'input'];

  clear(event) {
    event.preventDefault();
    this.inputTarget.value = '';
    this.formTarget.submit();
  }
}



// WEBPACK FOOTER //
// ./app/components/overviews/assets/javascript/overviews-search-controller.js